import React, {useEffect, useState} from 'react';
import {IonContent, IonModal, IonPage} from '@ionic/react';
import {useHistory} from 'react-router-dom';
import RoadTestToggle from './RoadTestToggle';
import {ApiService} from "../api/ApiService";
import {toastStore} from "../components/AppToast";
import LoadDetailHeader, {useTransparentHeaderContrast} from '../components/LoadDetailHeader';

const RoadTest = (props: any) => {
    const history = useHistory();
    const {onSheet, onIonScroll} = useTransparentHeaderContrast();
    const now = new Date()

    const [mounted, setMounted] = useState(false);
    const [showModal1, setShowModal1] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [comments, setComments] = useState<string>();
    const [startingScore, setStartingScore] = useState('');
    const [truckBackingScore, setTruckBackingScore] = useState('');
    const [hookUpScore, setHookUpScore] = useState('');
    const [preTripScore, setPreTripScore] = useState('');
    const [rampSpeedScore, setRampSpeedScore] = useState('');
    const [upgradeStartScore, setUpgradeStartScore] = useState('');
    const [lanePosScore, setLanePosScore] = useState('');
    const [shiftScore, setShiftScore] = useState('');
    const [useHornScore, setUseHornScore] = useState('');
    const [intersecSpeedScore, setIntersecSpeedScore] = useState('');
    const [distractionScore, setDistractionScore] = useState('');
    const [laneControlScore, setLaneControlScore] = useState('');
    const [seatBeltScore, setSeatBeltScore] = useState('');
    const [trafficLightScore, setTrafficLightScore] = useState('');
    const [stopSignScore, setStopSignScore] = useState('');
    const [otherSignScore, setOtherSignScore] = useState('');
    const [coastingScore, setCoastingScore] = useState('');
    const [laneChangeScore, setLaneChangeScore] = useState('');
    const [overTakeScore, setOverTakeScore] = useState('');
    const [unsafeDrivingScore, setUnsafeDrivingScore] = useState('');
    const [followDistScore, setFollowDistScore] = useState('');
    const [mirrorUseScore, setMirrorUseScore] = useState('');
    const [rightOfWayScore, setRightOfWayScore] = useState('');
    const [speedControlScore, setSpeedControlScore] = useState('');
    const [startStopScore, setStartStopScore] = useState('');
    const [highwaySignalScore, setHighwaySignalScore] = useState('');
    const [highwaySpeedScore, setHighwaySpeedScore] = useState('');
    const [highwayAprLaneScore, setHighwayAprLaneScore] = useState('');
    const [highwayEnterLaneScore, setHighwayEnterLaneScore] = useState('');
    const [highwayIntersecObservScore, setHighwayIntersecObservScore] = useState('');
    const [backingSetupScore, setBackingSetupScore] = useState('');
    const [backingSteerScore, setBackingSteerScore] = useState('');
    const [backingHornScore, setBackingHornScore] = useState('');
    const [backing4WayScore, setBacking4WayScore] = useState('');
    const [citySignalScore, setCitySignalScore] = useState('');
    const [citySpeedScore, setCitySpeedScore] = useState('');
    const [cityAprLaneScore, setCityAprLaneScore] = useState('');
    const [cityEnterLaneScore, setCityEnterLaneScore] = useState('');
    const [cityIntersecObservScor, setcityIntersecObservScore] = useState('');
    const [grade, setGrade] = useState('');

    useEffect(() => {
        const id = requestAnimationFrame(() => {
            setTimeout(() => setMounted(true), 30);
        });
        return () => cancelAnimationFrame(id);
    }, []);

    let autoFail = [
        {
            'answers': ["Good", "Auto Fail"],
            'name': 'Seat Belt Use',
            'value': seatBeltScore,
            'func': setSeatBeltScore
        },
        {
            'answers': ["Yes", "No"],
            'name': 'Backing Correct Setup',
            'value': backingSetupScore,
            'func': setBackingSetupScore
        },
        {
            'answers': ["Yes", "No"],
            'name': 'Backing Steers Properly',
            'value': backingSteerScore,
            'func': setBackingSteerScore
        },
        {
            'answers': ["Yes", "No"],
            'name': 'Backing Uses Goal And Horn',
            'value': backingHornScore,
            'func': setBackingHornScore
        },
        {
            'answers': ["Good", "Poor"],
            'name': 'Coasting Out Of Gear',
            'value': coastingScore,
            'func': setCoastingScore
        },
        {
            'answers': ["Good", "Auto Fail"],
            'name': 'Traffic Light',
            'value': trafficLightScore,
            'func': setTrafficLightScore
        },
        {
            'answers': ["Good", "Auto Fail"],
            'name': 'Stop Sign',
            'value': stopSignScore,
            'func': setStopSignScore
        },
    ]
    let pretrip = {
        name: "Pre Trip",
        info: "Inspection and understanding of safety proceedures prior to departure, etc. ?",
        eval: [
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Pre Trip Inspection',
                'value': preTripScore,
                'func': setPreTripScore,
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Starting On Upgrade',
                'value': upgradeStartScore,
                'func': setUpgradeStartScore,
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Starting',
                'value': startingScore,
                'func': setStartingScore,
            },
        ]
    }
    let backing = {
        name: "Backing",
        info: "Understanding of safety procedures, securing freight, backing proficiency etc.",
        eval: [
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Use Of Horn',
                'value': useHornScore,
                'func': setUseHornScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Backing Uses 4 Way Flashers',
                'value': backing4WayScore,
                'func': setBacking4WayScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Truck Backing',
                'value': truckBackingScore,
                'func': setTruckBackingScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Hook Up To Trailer',
                'value': hookUpScore,
                'func': setHookUpScore
            },
        ]
    }
    let safety = {
        name: "Safety",
        info: "Use of safety procedures in operation, railroad safety, sign knowledge (i.e. vertical clearance, bridge capacity, etc.)",
        eval: [
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Distraction',
                'value': distractionScore,
                'func': setDistractionScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Other Signs',
                'value': otherSignScore,
                'func': setOtherSignScore
            },
            {
                'answers': ["Good", "Fair", "Auto Fail"],
                'name': 'Unsafe Driving Action',
                'value': unsafeDrivingScore,
                'func': setUnsafeDrivingScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Use Of Mirrors',
                'value': mirrorUseScore,
                'func': setMirrorUseScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Right Of Way',
                'value': rightOfWayScore,
                'func': setRightOfWayScore
            },
            {
                'answers': ["Good", "Fair", "Auto Fail"],
                'name': 'Control Speed',
                'value': speedControlScore,
                'func': setSpeedControlScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Start And Stopping',
                'value': startStopScore,
                'func': setStartStopScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Following Distance',
                'value': followDistScore,
                'func': setFollowDistScore
            },
        ]
    }

    let highway = {
        name: "Highway Driving",
        info: "Determine safe following distance, understand emergency procedures (e.g. Flasher while traveling under 45 MPH, etc.)",
        eval: [
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'On Off Ramp Speed',
                'value': rampSpeedScore,
                'func': setRampSpeedScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Highway Signal',
                'value': highwaySignalScore,
                'func': setHighwaySignalScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Highway Speed',
                'value': highwaySpeedScore,
                'func': setHighwaySpeedScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Highway Approach Lane',
                'value': highwayAprLaneScore,
                'func': setHighwayAprLaneScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Highway Enter Lane',
                'value': highwayEnterLaneScore,
                'func': setHighwayEnterLaneScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Highway Intersection Observance',
                'value': highwayIntersecObservScore,
                'func': setHighwayIntersecObservScore
            },
        ]
    }
    let laneControl = {
        name: "Lane Control",
        info: "Lane control, changing & overtaking, 'No-Zone' awareness,  etc.",
        eval: [
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Lane Position',
                'value': lanePosScore,
                'func': setLanePosScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Lane Control',
                'value': laneControlScore,
                'func': setLaneControlScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Lane Changes',
                'value': laneChangeScore,
                'func': setLaneChangeScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Over Taking',
                'value': overTakeScore,
                'func': setOverTakeScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Shifting',
                'value': shiftScore,
                'func': setShiftScore
            },
        ]
    }

    let city = {
        name: "City Driving",
        info: "Max of 18 in. clearance while Turning, turning Speed, etc.",
        eval: [
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'City Signal',
                'value': citySignalScore,
                'func': setCitySignalScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'City Speed',
                'value': citySpeedScore,
                'func': setCitySpeedScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'City Approach Lane',
                'value': cityAprLaneScore,
                'func': setCityAprLaneScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'City Enter Lane',
                'value': cityEnterLaneScore,
                'func': setCityEnterLaneScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'City Intersection Observance',
                'value': cityIntersecObservScor,
                'func': setcityIntersecObservScore
            },
            {
                'answers': ["Good", "Fair", "Poor"],
                'name': 'Intersection Speed',
                'value': intersecSpeedScore,
                'func': setIntersecSpeedScore
            },
        ]
    }

    const getCompletetion = () => {
        let progression = 0
        let questions = Object.entries(progress).length
        Object.values(progress).forEach(question => {
            if (question === "Auto Fail" && grade !== "Fail") {
                setGrade("Fail")
            } else if (question !== "") {
                progression++
            }
        })
        return progression + "/" + questions
    }

    const progress = {
        starting: startingScore,
        truckBacking: truckBackingScore,
        hookUp: hookUpScore,
        preTripInspec: preTripScore,
        rampSpeed: rampSpeedScore,
        onUpgrade: upgradeStartScore,
        lanePos: lanePosScore,
        shifting: shiftScore,
        useHorn: useHornScore,
        intersectionSpeed: intersecSpeedScore,
        distraction: distractionScore,
        laneControl: laneControlScore,
        seatBelt: seatBeltScore,
        trafficLight: trafficLightScore,
        stopSign: stopSignScore,
        otherSign: otherSignScore,
        coastingOutGear: coastingScore,
        laneChange: laneChangeScore,
        overTaking: overTakeScore,
        unsafeDrivingAction: unsafeDrivingScore,
        followDistance: followDistScore,
        useMirrors: mirrorUseScore,
        rightOfWay: rightOfWayScore,
        controlSpeed: speedControlScore,
        startStop: startStopScore,
        highwaySignal: highwaySignalScore,
        highwaySpeed: highwaySpeedScore,
        highwayApproach: highwayAprLaneScore,
        highwayEnter: highwayEnterLaneScore,
        highwayInterObserv: highwayIntersecObservScore,
        backingSetup: backingSetupScore,
        backingSteering: backingSteerScore,
        backingHorn: backingHornScore,
        backing4Way: backing4WayScore,
        citySignal: citySignalScore,
        citySpeed: citySpeedScore,
        cityApproach: cityAprLaneScore,
        cityEnter: cityEnterLaneScore,
        cityInterObserv: cityIntersecObservScor,
        grade: grade,
    }

    const submitTest = () => {
        ApiService.submitRoadTest('roadTest', {
            traineeCode: props.traineeCode,
            trainerCode: props.trainerCode,
            starting: startingScore,
            truckBacking: truckBackingScore,
            hookUp: hookUpScore,
            preTripInspec: preTripScore,
            rampSpeed: rampSpeedScore,
            onUpgrade: upgradeStartScore,
            lanePos: lanePosScore,
            shifting: shiftScore,
            useHorn: useHornScore,
            intersectionSpeed: intersecSpeedScore,
            distraction: distractionScore,
            laneControl: laneControlScore,
            seatBelt: seatBeltScore,
            trafficLight: trafficLightScore,
            stopSign: stopSignScore,
            otherSign: otherSignScore,
            coastingOutGear: coastingScore,
            laneChange: laneChangeScore,
            overTaking: overTakeScore,
            unsafeDrivingAction: unsafeDrivingScore,
            followDistance: followDistScore,
            useMirrors: mirrorUseScore,
            rightOfWay: rightOfWayScore,
            controlSpeed: speedControlScore,
            startStop: startStopScore,
            highwaySignal: highwaySignalScore,
            highwaySpeed: highwaySpeedScore,
            highwayApproach: highwayAprLaneScore,
            highwayEnter: highwayEnterLaneScore,
            highwayInterObserv: highwayIntersecObservScore,
            backingSetup: backingSetupScore,
            backingSteering: backingSteerScore,
            backingHorn: backingHornScore,
            backing4Way: backing4WayScore,
            citySignal: citySignalScore,
            citySpeed: citySpeedScore,
            cityApproach: cityAprLaneScore,
            cityEnter: cityEnterLaneScore,
            cityInterObserv: cityIntersecObservScor,
            grade: grade
        }).then(reportId => {
            props.submittedTest?.();
            props.reportId?.(reportId);
            toastStore.getState().setSuccessToast('Road test has been submitted');
            setShowModal(true);
        }).finally(() => {
            setShowModal1(false);
        });
    }

    const handleSubmit = () => {
        if (grade !== '') {
            if (trafficLightScore === "Auto Fail" || seatBeltScore === "Auto Fail" || stopSignScore === "Auto Fail" || speedControlScore === "Auto Fail" || unsafeDrivingScore === "Auto Fail") {
                setGrade("Fail");
                submitTest();
            } else {
                submitTest();
            }
        } else {
            toastStore.getState().setToast('Please select a grade for the road test');
            setShowModal1(false);
        }
    }

    const goBack = () => {
      if (props.hideTest) props.hideTest();
      else if (history.length > 1) history.goBack();
      else history.replace('/Home');
    };

    const categories = [
        {key: 'general', name: 'General', info: 'Auto-fail items — any "Auto Fail" fails the test.', eval: autoFail},
        {key: 'pretrip', ...pretrip},
        {key: 'backing', ...backing},
        {key: 'safety', ...safety},
        {key: 'highway', ...highway},
        {key: 'laneControl', ...laneControl},
        {key: 'city', ...city},
    ];

    return (
        <IonPage>
            <LoadDetailHeader title="Road Test" onBack={goBack} onSheet={onSheet} />

            <IonContent
              fullscreen
              className="design-a-content design-a-content--light"
              scrollEvents={true}
              onIonScroll={onIonScroll}
            >
              <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
                <div className="home-hero advance-hero">
                  <div className="advance-hero__eyebrow">Road Test</div>
                  <div className="advance-hero__title home-display">{props.traineeCode || 'Road Test'}</div>
                  <div className="advance-hero__meta">Test Date: {now.toDateString()} · Completion: {getCompletetion()} · Grade: {grade || '—'}</div>
                </div>

                <div className="home-sheet advance-sheet">
                  {categories.map(cat => (
                    <div className="home-card roadtest-category" key={cat.key}>
                      <div className="roadtest-category__header">
                        <div className="roadtest-category__title">{cat.name}</div>
                        <div className="roadtest-category__info">{cat.info}</div>
                      </div>
                      <div className="roadtest-category__questions">
                        {cat.eval.map((question, qIdx) => (
                          <RoadTestToggle element={question} key={qIdx} />
                        ))}
                      </div>
                    </div>
                  ))}

                  <div className="home-card training-info-card">
                    <div className="training-info-card__label">Comments</div>
                    <textarea
                      id="comment-box"
                      className="profile-field__input"
                      style={{width: '100%', minHeight: '80px', resize: 'vertical'}}
                      value={comments}
                      onChange={e => setComments(e.target.value)}
                    />
                  </div>

                  <div className="home-card roadtest-grade">
                    <div className="roadtest-category__header">
                      <div className="roadtest-category__title">Overall Grade</div>
                      <div className="roadtest-category__info">Select a final grade for this road test.</div>
                    </div>
                    <RoadTestToggle element={{name: "Overall Grade", value: grade, func: setGrade, answers: ["Pass", "Fail"]}} />
                    <button type="button" className="profile-submit" onClick={() => setShowModal1(true)}>Submit</button>
                  </div>
                </div>
              </div>
            </IonContent>

            <IonModal isOpen={showModal} onDidDismiss={() => setShowModal(false)}>
              <div className="design-a">
                <div className="roadtest-confirm-modal">
                  <div className="roadtest-confirm-modal__title">Thank You</div>
                  <p className="roadtest-confirm-modal__body">Road test submitted.</p>
                  <button
                    type="button"
                    className="profile-submit"
                    onClick={() => { setShowModal(false); props.hideTest?.(); }}
                  >
                    Done
                  </button>
                </div>
              </div>
            </IonModal>

            <IonModal isOpen={showModal1} onDidDismiss={() => setShowModal1(false)}>
              <div className="design-a">
                <div className="roadtest-confirm-modal">
                  <div className="roadtest-confirm-modal__title">Confirm?</div>
                  <p className="roadtest-confirm-modal__body">Submit Test for Trainee: {props.traineeCode}?</p>
                  <button type="button" className="profile-submit" onClick={handleSubmit}>Confirm</button>
                  <button type="button" className="roadtest-confirm-modal__secondary" onClick={() => setShowModal1(false)}>Cancel</button>
                </div>
              </div>
            </IonModal>
        </IonPage>
    );
};

export default RoadTest;
